import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  packNotificationAction,
  schoolDetailAction,
} from "../../Redux/Action/AuthAction";
import { isOrganisationGroupUser } from "../../Util/authRedirect";
import SchoolInvitesOffcanvas from "./SchoolInvitesOffcanvas";

export default function Sidebar({ isActive, setIsActive, setShow, show }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showInvitesOffcanvas, setShowInvitesOffcanvas] = useState(false);
  const dataofstore = useSelector(
    (state) => state?.authSlice.userData?.payload,
  );
  const schoolData = useSelector((state) => state?.authSlice?.schoolDetail);
  const schoolDetailStatus = useSelector(
    (state) => state?.authSlice?.schoolDetailStatus,
  );
  const Notification = useSelector((state) => state?.authSlice?.notification);
  const notificationStatus = useSelector(
    (state) => state?.authSlice?.notificationStatus,
  );
  const userData = useSelector((state) => state?.authSlice.userData?.payload);

  const gotoDashBoard = () => {
    navigate(`/Dashboard`);
  };

  useEffect(() => {
    if (!userData?._id || isOrganisationGroupUser(userData)) return;

    if (schoolDetailStatus === "idle") {
      dispatch(schoolDetailAction());
    }

    if (userData?.role === "School" && notificationStatus === "idle") {
      dispatch(packNotificationAction());
    }
  }, [dispatch, notificationStatus, schoolDetailStatus, userData]);

  return (
    <aside>
      <div className="sidebar">
        <div className="toggle-icon" onClick={() => setShow(!show)}>
          <img src={require("../../Assets/Images/toggle.svg").default} />
        </div>
        <div
          className="logo-side"
          onClick={gotoDashBoard}
          style={{ cursor: "pointer" }}
        >
          <img
            className="small"
            src={require("../../Assets/Images/clogo.png")}
          />
          <img
            className="big"
            src={require("../../Assets/Images/main-logo.png")}
          />
        </div>
        <div className="side-menu">
          <div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/Dashboard"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/Dashboard"
              >
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                  width="24"
                >
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-5h2v5zm4 0h-2v-3h2v3zm0-5h-2v-2h2v2zm4 5h-2V7h2v10z" />
                </svg> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="-1.2 -1.2 24 24"
                  id="Finance-Fill--Streamline-Outlined-Fill-Material"
                  height="24"
                  width="24"
                >
                  <path
                    fill="#0e0e0e"
                    d="M4.05 18.900000000000002c-0.36000000000000004 0 -0.675 -0.135 -0.9450000000000001 -0.405 -0.27 -0.27 -0.405 -0.5850000000000001 -0.405 -0.9450000000000001V2.7h1.35v14.85h14.85v1.35H4.05Zm1.6875 -3.0375v-7.515h2.6775v7.515h-2.6775Zm4.455 0v-12.15h2.6775v12.15h-2.6775Zm4.365 0v-3.825h2.6775v3.825h-2.6775Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p> Dashboard</p>
              </Link>
            </div>
            <div className="side-btm-space">
              <Link
                className={
                  window.location.pathname == "/browse"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
                to="/browse"
              // onClick={()=>{
              //   window.location.href = "/browse";
              // }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  id="Video-Search-Fill--Streamline-Outlined-Fill-Material"
                  height="24"
                  width="24"
                >
                  <desc>
                    Video Search Fill Streamline Icon: https://streamlinehq.com
                  </desc>
                  <path
                    fill="#000000"
                    d="m19.9 20.9751 -6.575 -6.575c-0.5 0.43335 -1.08335 0.77085 -1.75 1.0125 -0.66665 0.24165 -1.375 0.3625 -2.125 0.3625 -1.8 0 -3.325 -0.625 -4.575 -1.875S3 11.14175 3 9.3751c0 -1.76665 0.625 -3.275 1.875 -4.525 1.25 -1.25 2.76665 -1.875 4.55 -1.875 1.76665 0 3.27085 0.625 4.5125 1.875 1.24165 1.25 1.8625 2.75835 1.8625 4.525 0 0.71665 -0.11665 1.40835 -0.35 2.075 -0.23335 0.66665 -0.58335 1.29165 -1.05 1.875l6.6 6.55 -1.1 1.1Zm-10.475 -6.7c1.35 0 2.5 -0.47915 3.45 -1.4375 0.95 -0.95835 1.425 -2.1125 1.425 -3.4625s-0.475 -2.50415 -1.425 -3.4625c-0.95 -0.958335 -2.1 -1.4375 -3.45 -1.4375 -1.36665 0 -2.52915 0.479165 -3.4875 1.4375C4.979165 6.87095 4.5 8.0251 4.5 9.3751s0.479165 2.50415 1.4375 3.4625c0.95835 0.95835 2.12085 1.4375 3.4875 1.4375Zm-1.475 -2.5v-4.825l3.85 2.4 -3.85 2.425Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>Browse</p>
              </Link>
            </div>
            <Link
              to="/collections"
              className={
                window.location.pathname == "/collections"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                id="Collections-Bookmark-Fill--Streamline-Outlined-Fill-Material"
                height="24"
                width="24"
              >
                <desc>
                  Collections Bookmark Fill Streamline Icon:
                  https://streamlinehq.com
                </desc>
                <path
                  fill="#000000"
                  d="M3.5 22c-0.4 0 -0.75 -0.15 -1.05 -0.45 -0.3 -0.3 -0.45 -0.65 -0.45 -1.05V5h1.5v15.5h15.5v1.5H3.5Zm3 -3c-0.4 0 -0.75 -0.15 -1.05 -0.45 -0.3 -0.3 -0.45 -0.65 -0.45 -1.05V3.5c0 -0.4 0.15 -0.75 0.45 -1.05 0.3 -0.3 0.65 -0.45 1.05 -0.45h14c0.4 0 0.75 0.15 1.05 0.45 0.3 0.3 0.45 0.65 0.45 1.05v14c0 0.4 -0.15 0.75 -0.45 1.05 -0.3 0.3 -0.65 0.45 -1.05 0.45H6.5Zm7.175 -8.55L16 9.025l2.325 1.425V3.5h-4.65v6.95Z"
                  strokeWidth="0.5"
                />
              </svg>

              <p>Collections</p>
            </Link>

            <Link
              to="/packs"
              className={
                window.location.pathname == "/packs"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
              style={{ position: "relative" }}
            >
              {userData.role === "School" && Notification?.notifyCount > 0 && (
                <span className="sidebar-notification-dot"></span>
              )}
              <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="m380-240 280-180-280-180v360ZM160-120q-33 0-56.5-23.5T80-200v-520h240v-80q0-33 23.5-56.5T400-880h160q33 0 56.5 23.5T640-800v80h240v520q0 33-23.5 56.5T800-120H160Zm0-80h640v-440H160v440Zm240-520h160v-80H400v80ZM160-200v-440 440Z" /></svg>
              <p>Strategy Packs</p>
            </Link>

            {schoolData?.schoolId?.learnerAccessible && (
              <Link
                to="/students"
                className={
                  window.location.pathname == "/students"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 9C11.4862 9 13.5 6.98625 13.5 4.5C13.5 2.01375 11.4862 0 9 0C6.51375 0 4.5 2.01375 4.5 4.5C4.5 6.98625 6.51375 9 9 9ZM9 11.25C5.99625 11.25 0 12.7575 0 15.75V16.875C0 17.4937 0.50625 18 1.125 18H16.875C17.4937 18 18 17.4937 18 16.875V15.75C18 12.7575 12.0037 11.25 9 11.25Z"
                    fill="black"
                    fillOpacity="0.8"
                  />
                </svg>

                <p>Learners</p>
              </Link>
            )}

            {schoolData?.learnerAccessible && (
              <Link
                to="/students"
                className={
                  window.location.pathname == "/students"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  id="Person-Raised-Hand--Streamline-Rounded-Material"
                  height="24"
                  width="24"
                >
                  <desc>
                    Person Raised Hand Streamline Icon: https://streamlinehq.com
                  </desc>
                  <path
                    fill="#000000"
                    d="M2.75 22.9999c-0.2125 0 -0.390585 -0.07235 -0.53425 -0.217 -0.143835 -0.1445 -0.21575 -0.32365 -0.21575 -0.5375 0 -0.21365 0.071915 -0.39135 0.21575 -0.533 0.143665 -0.14165 0.32175 -0.2125 0.53425 -0.2125h18.5c0.2125 0 0.39065 0.07235 0.5345 0.217 0.14365 0.1445 0.2155 0.32365 0.2155 0.5375 0 0.21365 -0.07185 0.39135 -0.2155 0.533 -0.14385 0.14165 -0.322 0.2125 -0.5345 0.2125h-18.5Zm2 -3c-0.2125 0 -0.390585 -0.0719 -0.53425 -0.21575C4.071915 19.6405 4 19.4624 4 19.2499v-4.5c-0.65 -1.51665 -1.1 -2.74585 -1.35 -3.6875 -0.25 -0.94165 -0.375 -1.8875 -0.375 -2.8375 0 -0.96665 0.120835 -1.98335 0.3625 -3.05 0.241665 -1.066665 0.579165 -2.075 1.0125 -3.025 0.166665 -0.366665 0.387085 -0.64583 0.66125 -0.8375 0.274165 -0.191665 0.57875 -0.2875 0.91375 -0.2875 0.45 0 0.79165 0.145835 1.025 0.4375 0.23335 0.29167 0.35 0.72917 0.35 1.3125v3.275c0 0.73335 0.14165 1.425 0.425 2.075 0.28335 0.65 0.67085 1.21665 1.1625 1.7 0.49165 0.48335 1.06075 0.8625 1.70725 1.1375 0.6465 0.275 1.34825 0.4125 2.10525 0.4125 1.35 0 2.525 0.1 3.525 0.3 1 0.2 1.83335 0.49165 2.5 0.875s1.1625 0.87085 1.4875 1.4625c0.325 0.59165 0.4875 1.2875 0.4875 2.0875v3.15c0 0.2125 -0.07185 0.3906 -0.2155 0.53425 -0.14385 0.14385 -0.322 0.21575 -0.5345 0.21575h-14.5Zm0.75 -1.5h13v-2.4c0 -0.55 -0.13335 -1.025 -0.4 -1.425 -0.26665 -0.4 -0.66665 -0.73335 -1.2 -1 -0.53335 -0.26665 -1.20835 -0.46665 -2.025 -0.6 -0.81665 -0.13335 -1.775 -0.2 -2.875 -0.2 -0.95 0 -1.84585 -0.17915 -2.6875 -0.5375 -0.84165 -0.35835 -1.575 -0.84585 -2.2 -1.4625 -0.625 -0.61665 -1.12085 -1.34165 -1.4875 -2.175 -0.36665 -0.83335 -0.55 -1.725 -0.55 -2.675v-3.25c-0.383335 0.75 -0.695835 1.620835 -0.9375 2.6125 -0.241665 0.99165 -0.3625 1.9375 -0.3625 2.8375 0 0.85 0.129165 1.72915 0.3875 2.6375 0.258335 0.90835 0.704165 2.0625 1.3375 3.4625v4.175Zm6.5 -8.5c-1.1 0 -2.04165 -0.39165 -2.825 -1.175s-1.175 -1.725 -1.175 -2.825 0.39165 -2.041665 1.175 -2.825c0.78335 -0.78333 1.725 -1.175 2.825 -1.175s2.04165 0.39167 2.825 1.175c0.78335 0.783335 1.175 1.725 1.175 2.825s-0.39165 2.04165 -1.175 2.825 -1.725 1.175 -2.825 1.175Zm0 -1.5c0.7 0 1.29165 -0.24165 1.775 -0.725 0.48335 -0.48335 0.725 -1.075 0.725 -1.775s-0.24165 -1.291665 -0.725 -1.775c-0.48335 -0.48333 -1.075 -0.725 -1.775 -0.725s-1.29165 0.24167 -1.775 0.725c-0.48335 0.483335 -0.725 1.075 -0.725 1.775s0.24165 1.29165 0.725 1.775c0.48335 0.48335 1.075 0.725 1.775 0.725Zm-3.75 11.5v-0.925c0 -1.05 0.36325 -1.95 1.08975 -2.7 0.72665 -0.75 1.6134 -1.125 2.66025 -1.125h3c0.2125 0 0.39065 0.07235 0.5345 0.217 0.14365 0.1445 0.2155 0.32365 0.2155 0.5375 0 0.21365 -0.07185 0.39135 -0.2155 0.533 -0.14385 0.14165 -0.322 0.2125 -0.5345 0.2125h-3c-0.6375 0 -1.17185 0.22875 -1.603 0.68625 -0.43135 0.4575 -0.647 1.00375 -0.647 1.63875v0.925h-1.5Z"
                    strokeWidth="0.5"
                  />
                </svg>

                <p>Learners</p>
              </Link>
            )}
            
            <Link
              to="/parents"
              className={
                window.location.pathname == "/parents"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              {/* <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 9C11.4862 9 13.5 6.98625 13.5 4.5C13.5 2.01375 11.4862 0 9 0C6.51375 0 4.5 2.01375 4.5 4.5C4.5 6.98625 6.51375 9 9 9ZM9 11.25C5.99625 11.25 0 12.7575 0 15.75V16.875C0 17.4937 0.50625 18 1.125 18H16.875C17.4937 18 18 17.4937 18 16.875V15.75C18 12.7575 12.0037 11.25 9 11.25Z"
                    fill="black"
                    fillOpacity="0.8"
                  />
                </svg> */}
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12 0C13.0462 0 13.9231 0.344569 14.6308 1.03371C15.3385 1.72285 15.6923 2.57678 15.6923 3.59551C15.6923 4.61423 15.3385 5.46816 14.6308 6.1573C13.9231 6.84644 13.0462 7.19101 12 7.19101C10.9538 7.19101 10.0769 6.84644 9.36923 6.1573C8.66154 5.46816 8.30769 4.61423 8.30769 3.59551C8.30769 2.57678 8.66154 1.72285 9.36923 1.03371C10.0769 0.344569 10.9538 0 12 0ZM12 8.38951C12.9436 8.38951 13.8872 8.50936 14.8308 8.74906C15.7743 8.98876 16.6257 9.30835 17.3846 9.70787C18.1641 10.1074 18.7949 10.5718 19.2769 11.1011C19.759 11.6304 20 12.1948 20 12.794V19.7154C20 20.4544 19.759 21.0936 19.2769 21.633C18.7949 22.1723 18.1846 22.4419 17.4462 22.4419C17.241 22.4419 17.0666 22.372 16.9231 22.2322C16.7795 22.0924 16.7077 21.8327 16.7077 21.4532V20.3446C16.7077 19.5855 16.1897 18.9813 15.1538 18.5318C14.118 18.0824 13.0666 17.8577 12 17.8577C11.118 17.8577 10.2564 17.9975 9.41538 18.2772C8.57434 18.5568 7.94874 18.9263 7.53846 19.3858C7.41538 19.5456 7.38462 19.7154 7.44615 19.8951C7.50769 20.0749 7.64105 20.2048 7.84615 20.2846C8.50258 20.5044 9.18972 20.6542 9.90769 20.7341C10.6257 20.814 11.3538 20.8639 12.0923 20.8839C12.5436 20.8839 12.9231 21.0337 13.2308 21.3333C13.5385 21.633 13.6923 22.0025 13.6923 22.4419C13.6923 22.8814 13.5385 23.2509 13.2308 23.5506C12.9231 23.8502 12.5436 24 12.0923 24C11.3743 24 10.5487 23.9251 9.61538 23.7753C8.68203 23.6255 7.79489 23.3808 6.95385 23.0412C6.1128 22.7016 5.41028 22.2622 4.84615 21.7228C4.28203 21.1835 4 20.5143 4 19.7154V12.794C4 12.1948 4.23588 11.6304 4.70769 11.1011C5.17951 10.5718 5.80511 10.1074 6.58462 9.70787C7.36412 9.30835 8.22566 8.98876 9.16923 8.74906C10.1128 8.50936 11.0564 8.38951 12 8.38951ZM12 15.5805C12.718 15.5805 13.3077 15.3558 13.7692 14.9064C14.2308 14.4569 14.4615 13.8827 14.4615 13.1835C14.4615 12.4844 14.2308 11.9101 13.7692 11.4607C13.3077 11.0112 12.718 10.7865 12 10.7865C11.282 10.7865 10.6923 11.0112 10.2308 11.4607C9.76923 11.9101 9.53846 12.4844 9.53846 13.1835C9.53846 13.8827 9.76923 14.4569 10.2308 14.9064C10.6923 15.3558 11.282 15.5805 12 15.5805Z"
                  fill="black"
                />
              </svg>

              <p>Parents</p>
            </Link>

            {schoolData?.schoolId?.learnerAccessible && (
              <div className="side-btm-space">
                <Link
                  to="/classes"
                  className={
                    window.location.pathname == "/classes"
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                >
                  <svg
                    width="21"
                    height="18"
                    viewBox="0 0 21 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.000186133 9.84367C0.0252054 9.74218 0.0534594 9.6413 0.0748066 9.53908C0.409517 7.93833 1.67336 6.75864 3.32644 6.50447C3.41338 6.49112 3.49958 6.47295 3.63053 6.44882C2.88157 6.34331 2.28939 6.03519 1.83549 5.49191C1.37749 4.9437 1.18872 4.30991 1.2359 3.60633C1.31774 2.38622 2.34733 1.35916 3.63177 1.21507C4.88541 1.07445 6.12399 1.88275 6.47861 3.07238C6.70366 3.82728 6.60029 4.5408 6.18604 5.20952C5.77017 5.88092 5.14239 6.26297 4.36872 6.44577C5.1595 6.41883 5.85967 6.68446 6.54235 7.01958C7.62178 7.54945 8.70365 8.07462 9.78458 8.60162C9.83841 8.62789 9.89318 8.65234 9.95983 8.68336C10.002 8.60662 10.0419 8.53817 10.0779 8.46777C10.4656 7.70957 10.8537 6.95162 11.2391 6.19239C11.3671 5.94022 11.5653 5.79796 11.8569 5.81356C12.2943 5.83691 12.5587 6.27528 12.3713 6.67825C12.216 7.01227 12.0384 7.33636 11.8707 7.66483C11.5566 8.28003 11.2387 8.89335 10.9327 9.51239C10.8862 9.60644 10.8641 9.73292 10.8841 9.83428C11.0616 10.7346 10.3553 11.6532 9.42715 11.7382C9.05186 11.7725 8.71062 11.6979 8.38076 11.5369C7.77152 11.2396 7.16241 10.9421 6.51147 10.6242C6.51147 10.7297 6.51147 10.8051 6.51147 10.8806C6.51147 12.989 6.5116 15.0974 6.51141 17.2058C6.51135 17.7789 6.29165 17.9943 5.70787 17.9944C4.49139 17.9945 3.27484 17.9948 2.05836 17.9942C1.55231 17.994 1.31494 17.7637 1.31469 17.2736C1.31413 16.2495 1.31419 15.2254 1.315 14.2013C1.31506 14.1001 1.32116 14.0187 1.19084 13.9643C0.578304 13.7087 0.1981 13.2545 0.0431298 12.6197C0.035848 12.5898 0.0146879 12.5632 0 12.5351C0.000186711 11.6379 0.000186133 10.7408 0.000186133 9.84367Z"
                      fill="black"
                      fillOpacity="0.8"
                    />
                    <path
                      d="M15.9742 10.8874C16.1311 11.3086 16.2769 11.7021 16.4243 12.095C17.0426 13.7427 17.66 15.3907 18.2817 17.0371C18.3824 17.3036 18.4184 17.5546 18.2052 17.786C17.925 18.0902 17.4414 18.0463 17.2282 17.694C17.1799 17.6142 17.143 17.5266 17.1102 17.4392C16.3152 15.3218 15.5197 13.2046 14.7312 11.0849C14.6758 10.9359 14.6116 10.8795 14.4437 10.8799C14.2783 10.8803 14.2082 10.9313 14.153 11.0811C13.374 13.1971 12.592 15.312 11.7983 17.4227C11.7315 17.6005 11.6065 17.784 11.4559 17.8985C11.2517 18.0538 11.0031 18.0213 10.7893 17.8661C10.5798 17.714 10.487 17.4584 10.5772 17.2053C10.8264 16.5059 11.0873 15.8104 11.3455 15.1142C11.8413 13.778 12.3386 12.4423 12.8347 11.1062C12.8577 11.0443 12.8748 10.9802 12.9013 10.8959C12.6112 10.8959 12.3357 10.8959 12.0732 10.8959C12.0945 10.5357 12.1119 10.1935 12.1379 9.8519C12.1422 9.79545 12.1808 9.74047 12.2081 9.68696C12.6156 8.88615 13.027 8.08724 13.4311 7.28485C13.7748 6.60242 13.7382 5.94351 13.2767 5.32039C12.5583 4.35062 10.9455 4.38939 10.3042 5.41036C10.0084 5.88122 9.77785 6.39134 9.51764 6.8836C9.48652 6.94248 9.45497 7.00105 9.41296 7.0798C9.09792 6.92748 8.80042 6.7445 8.47679 6.63655C8.01362 6.48204 7.87782 6.21902 7.8945 5.73627C7.93956 4.43236 7.89401 3.12577 7.92226 1.82101C7.94454 0.792725 8.78082 0.0187411 9.832 0.00453898C10.4949 -0.00442114 11.158 0.00264942 11.821 0.00264942C14.1928 0.00264942 16.5647 0.00234465 18.9365 0.00277132C20.1871 0.00295418 20.9994 0.799064 20.9997 2.02459C21 4.30729 21.0002 6.59005 20.9997 8.87274C20.9994 10.0857 20.1842 10.8864 18.9495 10.8872C18.0404 10.8879 17.1313 10.8874 16.2222 10.8874C16.1496 10.8874 16.0769 10.8874 15.9742 10.8874ZM14.4363 3.78218C15.5294 3.78218 16.6225 3.78419 17.7156 3.7812C18.1538 3.77998 18.4334 3.43864 18.3372 3.03434C18.271 2.75572 18.0305 2.58725 17.6689 2.58688C15.5237 2.58457 13.3785 2.5856 11.2333 2.58652C11.1722 2.58652 11.1105 2.59377 11.0501 2.60395C10.8125 2.64424 10.6556 2.78273 10.582 3.00295C10.4493 3.39982 10.7371 3.77894 11.1776 3.78065C12.2638 3.78474 13.3501 3.78193 14.4363 3.78218ZM16.3724 7.10827C16.3724 7.1087 16.3724 7.10912 16.3724 7.10955C15.9007 7.10955 15.429 7.1037 14.9575 7.11162C14.654 7.11674 14.4123 7.3519 14.3892 7.6407C14.3631 7.96777 14.5547 8.2328 14.8712 8.28259C15.025 8.30679 15.1841 8.30509 15.3408 8.30551C16.1268 8.3074 16.9129 8.31203 17.6989 8.3035C18.1044 8.29911 18.3679 8.03951 18.3567 7.68702C18.3456 7.34056 18.0791 7.10985 17.6847 7.10857C17.2473 7.10717 16.8098 7.10827 16.3724 7.10827ZM16.3685 6.0386C16.8126 6.0386 17.2566 6.04202 17.7006 6.03757C18.0948 6.03366 18.3578 5.79284 18.3583 5.44583C18.359 5.09883 18.0958 4.85428 17.7024 4.85257C16.8144 4.84867 15.9262 4.84873 15.0382 4.85245C14.6404 4.8541 14.3854 5.09127 14.3849 5.44406C14.3845 5.79711 14.6395 6.0336 15.0364 6.03757C15.4804 6.04202 15.9244 6.0386 16.3685 6.0386Z"
                      fill="black"
                      fillOpacity="0.8"
                    />
                  </svg>

                  <p>Classes</p>
                </Link>
              </div>
            )}

            {schoolData?.learnerAccessible && (
              <div className="side-btm-space">
                <Link
                  to="/classes"
                  className={
                    window.location.pathname == "/classes"
                      ? "menu-btn bar_active"
                      : "menu-btn "
                  }
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    id="Groups--Streamline-Rounded-Material"
                    height="24"
                    width="24"
                  >
                    <desc>
                      Groups Streamline Icon: https://streamlinehq.com
                    </desc>
                    <path
                      fill="#000000"
                      d="M0.75 18c-0.2125 0 -0.3905835 -0.0719 -0.53425 -0.21575C0.0719165 17.6406 0 17.4625 0 17.25v-0.575c0 -0.64285 0.3458335 -1.166 1.0375 -1.5695C1.729165 14.70185 2.6365 14.5 3.7595 14.5c0.202665 0 0.397585 0.00415 0.58475 0.0125 0.187165 0.00835 0.372415 0.02625 0.55575 0.05375 -0.133335 0.28915 -0.233335 0.58225 -0.3 0.87925 -0.066665 0.29685 -0.1 0.60665 -0.1 0.9295V18H0.75Zm6 0c-0.2125 0 -0.3906 -0.0719 -0.53425 -0.21575C6.0719 17.6406 6 17.4625 6 17.25v-0.875c0 -0.53335 0.14585 -1.02085 0.4375 -1.4625 0.29165 -0.44165 0.70415 -0.82915 1.2375 -1.1625 0.53335 -0.33335 1.17085 -0.58335 1.9125 -0.75 0.74165 -0.16665 1.54585 -0.25 2.4125 -0.25 0.88335 0 1.69585 0.08335 2.4375 0.25 0.74165 0.16665 1.37915 0.41665 1.9125 0.75s0.94165 0.72085 1.225 1.1625c0.28335 0.44165 0.425 0.92915 0.425 1.4625v0.875c0 0.2125 -0.07185 0.3906 -0.2155 0.53425 -0.14385 0.14385 -0.322 0.21575 -0.5345 0.21575h-10.5ZM19.5 18v-1.625c0 -0.331 -0.02915 -0.6429 -0.0875 -0.93575 -0.05835 -0.29285 -0.15415 -0.58315 -0.2875 -0.871 0.18335 -0.02885 0.3681 -0.0474 0.55425 -0.05575 0.18615 -0.00835 0.3764 -0.0125 0.57075 -0.0125 1.125 0 2.03125 0.1981 2.71875 0.59425C23.65625 15.4904 24 16.01735 24 16.675v0.575c0 0.2125 -0.07185 0.3906 -0.2155 0.53425 -0.14385 0.14385 -0.322 0.21575 -0.5345 0.21575H19.5Zm-12 -1.5h9v-0.15c0 -0.61665 -0.42085 -1.12085 -1.2625 -1.5125C14.39585 14.44585 13.31665 14.25 12 14.25c-1.31665 0 -2.39585 0.19585 -3.2375 0.5875C7.92085 15.22915 7.5 15.74165 7.5 16.375V16.5Zm-3.76075 -2.75c-0.476165 0 -0.885085 -0.17135 -1.22675 -0.514C2.170835 12.89315 2 12.48115 2 12c0 -0.48335 0.171335 -0.89585 0.514 -1.2375 0.342835 -0.34165 0.754835 -0.5125 1.236 -0.5125 0.483335 0 0.895835 0.17085 1.2375 0.5125 0.34165 0.34165 0.5125 0.75775 0.5125 1.24825 0 0.47615 -0.17085 0.8851 -0.5125 1.22675 -0.341665 0.34165 -0.75775 0.5125 -1.24825 0.5125Zm16.5 0c-0.47615 0 -0.8851 -0.17135 -1.22675 -0.514C18.67085 12.89315 18.5 12.48115 18.5 12c0 -0.48335 0.17135 -0.89585 0.514 -1.2375 0.34285 -0.34165 0.75485 -0.5125 1.236 -0.5125 0.48335 0 0.89585 0.17085 1.2375 0.5125 0.34165 0.34165 0.5125 0.75775 0.5125 1.24825 0 0.47615 -0.17085 0.8851 -0.5125 1.22675 -0.34165 0.34165 -0.75775 0.5125 -1.24825 0.5125ZM12 12c-0.83335 0 -1.54165 -0.29165 -2.125 -0.875S9 9.83335 9 9c0 -0.85 0.29165 -1.5625 0.875 -2.1375C10.45835 6.2875 11.16665 6 12 6c0.85 0 1.5625 0.2875 2.1375 0.8625C14.7125 7.4375 15 8.15 15 9c0 0.83335 -0.2875 1.54165 -0.8625 2.125C13.5625 11.70835 12.85 12 12 12Zm0.00875 -1.5c0.4275 0 0.7829 -0.1446 1.06625 -0.43375 0.28335 -0.28915 0.425 -0.6475 0.425 -1.075s-0.1429 -0.7829 -0.42875 -1.06625c-0.28585 -0.28335 -0.64 -0.425 -1.0625 -0.425s-0.7796 0.1429 -1.07125 0.42875c-0.29165 0.28585 -0.4375 0.64 -0.4375 1.0625s0.1446 0.7796 0.43375 1.07125c0.28915 0.29165 0.6475 0.4375 1.075 0.4375Z"
                      strokeWidth="0.5"
                    />
                  </svg>

                  <p>Classes</p>
                </Link>
              </div>
            )}

            {dataofstore && dataofstore.role === "Teacher" ? null : (
              <Link
                to="/teachers"
                className={
                  window.location.pathname == "/teachers"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  id="School-Fill--Streamline-Outlined-Fill-Material"
                  height="24"
                  width="24"
                >
                  <desc>
                    School Fill Streamline Icon: https://streamlinehq.com
                  </desc>
                  <path
                    fill="#000000"
                    d="M21.5 16.925v-7.05L11.975 15 1 9 11.975 3 23 9v7.925h-1.5ZM11.975 21l-7.25 -3.975v-5.25l7.25 3.975 7.25 -3.975v5.25L11.975 21Z"
                    strokeWidth="0.5"
                  />
                </svg>

                <p>Teachers</p>
              </Link>
            )}

            {dataofstore && dataofstore.role === "School" && (
              <Link
                to="/manage-admin"
                className={
                  window.location.pathname == "/manage-admin"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  id="Passkey--Streamline-Outlined-Material"
                  height="24"
                  width="24"
                >
                  <desc>Passkey Streamline Icon: https://streamlinehq.com</desc>
                  <path
                    fill="#000000"
                    d="M3 20v-2.35c0 -0.63335 0.158335 -1.175 0.475 -1.625 0.316665 -0.45 0.725 -0.79165 1.225 -1.025 1.11665 -0.5 2.1875 -0.875 3.2125 -1.125S9.96665 13.5 11 13.5c0.43335 0 0.85415 0.02085 1.2625 0.0625s0.82915 0.10415 1.2625 0.1875c-0.08335 0.96665 0.09585 1.87915 0.5375 2.7375C14.50415 17.34585 15.15 18.01665 16 18.5v1.5H3Zm16 3.675 -1.5 -1.5v-4.65c-0.73335 -0.21665 -1.33335 -0.62915 -1.8 -1.2375 -0.46665 -0.60835 -0.7 -1.3125 -0.7 -2.1125 0 -0.96665 0.34165 -1.79165 1.025 -2.475 0.68335 -0.68335 1.50835 -1.025 2.475 -1.025s1.79165 0.34165 2.475 1.025c0.68335 0.68335 1.025 1.50835 1.025 2.475 0 0.75 -0.2125 1.41665 -0.6375 2 -0.425 0.58335 -0.9625 1 -1.6125 1.25l1.25 1.25 -1.5 1.5 1.5 1.5 -2 2ZM11 11.5c-1.05 0 -1.9375 -0.3625 -2.6625 -1.0875 -0.725 -0.725 -1.0875 -1.6125 -1.0875 -2.6625s0.3625 -1.9375 1.0875 -2.6625C9.0625 4.3625 9.95 4 11 4s1.9375 0.3625 2.6625 1.0875c0.725 0.725 1.0875 1.6125 1.0875 2.6625s-0.3625 1.9375 -1.0875 2.6625C12.9375 11.1375 12.05 11.5 11 11.5Zm7.5 3.175c0.28335 0 0.52085 -0.09585 0.7125 -0.2875S19.5 13.95835 19.5 13.675c0 -0.28335 -0.09585 -0.52085 -0.2875 -0.7125s-0.42915 -0.2875 -0.7125 -0.2875c-0.28335 0 -0.52085 0.09585 -0.7125 0.2875S17.5 13.39165 17.5 13.675c0 0.28335 0.09585 0.52085 0.2875 0.7125s0.42915 0.2875 0.7125 0.2875Z"
                    strokeWidth="0.5"
                  />
                </svg>
                <p>Manage Admin</p>
              </Link>
            )}
            {dataofstore?.role == "SchoolAdmin" &&
              schoolData?.permissionToManageAdmins ? (
              <Link
                to="/manage-admin"
                className={
                  window.location.pathname == "/manage-admin"
                    ? "menu-btn bar_active"
                    : "menu-btn "
                }
              >
                <svg
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.64997 18C6.50962 17.9679 6.36326 17.9519 6.22893 17.9018C5.22246 17.5349 4.31023 17.0036 3.4862 16.32C3.06317 15.9691 2.96292 15.4559 3.18547 14.9046C3.57843 13.9263 3.43007 13.0281 2.73235 12.2382C2.34741 11.8032 1.8522 11.5546 1.27478 11.4744C0.553008 11.3742 0.218186 11.0574 0.103906 10.3277C-0.0604973 9.28919 -0.0264137 8.2507 0.182098 7.22024C0.292368 6.67293 0.677313 6.33813 1.25072 6.26195C2.88673 6.04544 3.84308 4.4817 3.28772 2.92999C3.07319 2.33056 3.21554 1.84941 3.71877 1.46248C4.4646 0.88711 5.2786 0.432022 6.15876 0.099227C6.7061 -0.107266 7.18528 0.0110162 7.56621 0.45207C8.64486 1.70306 10.3671 1.70506 11.4417 0.458084C11.8307 0.00500187 12.3018 -0.109271 12.8632 0.103237C13.8276 0.468108 14.7057 0.97933 15.5017 1.63289C15.9588 2.00779 16.0951 2.47089 15.9047 3.02622C15.3834 4.54986 16.2535 6.04944 17.8314 6.34214C18.4188 6.4504 18.7476 6.7852 18.8559 7.36659C19.0584 8.44316 19.0424 9.51573 18.8399 10.5903C18.7416 11.1075 18.3507 11.4744 17.8194 11.5566C16.1894 11.8032 15.2671 13.379 15.8465 14.9267C16.055 15.482 15.9247 15.9651 15.4676 16.342C14.7278 16.9475 13.9158 17.4326 13.0316 17.7955C12.5003 18.014 11.981 17.8757 11.6161 17.4246C10.5235 16.0694 8.67092 16.0934 7.61433 17.4788C7.37174 17.7975 7.06097 17.9739 6.64997 18ZM12.6707 8.97443C12.6707 7.24831 11.2472 5.8229 9.52101 5.8209C7.7627 5.8209 6.33519 7.23428 6.3372 8.97844C6.3392 10.7346 7.75067 12.148 9.50497 12.152C11.2533 12.154 12.6707 10.7306 12.6707 8.97443Z"
                    fill="black"
                    fillOpacity="0.8"
                  />
                </svg>

                <p>Manage Admin</p>
              </Link>
            ) : null}

            {dataofstore?.role === "School" && (
              <div className="side-btm-space">
                <button
                  type="button"
                  className={showInvitesOffcanvas ? "menu-btn bar_active" : "menu-btn"}
                  onClick={() => setShowInvitesOffcanvas(true)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    height="24"
                    width="24"
                  >
                    <path
                      fill="#000000"
                      d="M3.25 19.5c-0.35 0 -0.646 -0.121 -0.888 -0.363C2.121 18.896 2 18.6 2 18.25V5.75c0 -0.35 0.121 -0.646 0.362 -0.888C2.604 4.621 2.9 4.5 3.25 4.5h17.5c0.35 0 0.646 0.121 0.888 0.362 0.241 0.242 0.362 0.538 0.362 0.888v12.5c0 0.35 -0.121 0.646 -0.362 0.887 -0.242 0.242 -0.538 0.363 -0.888 0.363H3.25Zm8.75 -6.5 8.5 -5.5H3.5l8.5 5.5Zm0 1.75L3.5 9.25v9h17v-9l-8.5 5.5Z"
                      strokeWidth="0.5"
                    />
                  </svg>
                  <p>Group Invites</p>
                </button>
              </div>
            )}

            {/* <Link
              to="/likes"
              className={
                window.location.pathname == "/likes"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
              // onClick={()=>{
              //   window.location.href = "/likes";
              // }}
            >
              <svg
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 5.61745C20 5.91948 20 6.2235 20 6.52553C19.9901 6.56954 19.9743 6.61354 19.9703 6.65955C19.8674 7.85966 19.4378 8.93975 18.7924 9.94185C18.1134 10.9979 17.284 11.928 16.3615 12.7601C14.5264 14.4163 12.6616 16.0404 10.8028 17.6686C10.2782 18.1286 9.69222 18.1046 9.14387 17.6286C7.72252 16.3944 6.29918 15.1603 4.88575 13.9162C3.68611 12.8601 2.52211 11.768 1.56794 10.4739C0.841424 9.48581 0.281197 8.41371 0.095115 7.18359C-0.199845 5.24341 0.174299 3.45325 1.4551 1.93911C2.7359 0.424971 4.39877 -0.175084 6.34669 0.0749387C7.6077 0.236954 8.62719 0.883012 9.4804 1.8131C9.66055 2.00912 9.82287 2.21914 10.005 2.43716C10.0941 2.32115 10.1713 2.21514 10.2524 2.11513C10.3395 2.00912 10.4286 1.90311 10.5217 1.8031C12.0717 0.154945 13.9424 -0.397105 16.0863 0.286958C18.0956 0.927017 19.2695 2.40915 19.7961 4.43734C19.8971 4.82338 19.9347 5.22341 20 5.61745Z"
                  fill="black"
                  fillOpacity="0.8"
                />
              </svg>

              <p>Likes</p>
            </Link> */}
            <Link
              // to="/resource-mapping"
              to={
                "https://www.peerscroller.com/resources/pshe-association-content-guide"
              }
              target="_blank"
              rel="noopener noreferrer"
              // onClick={() => {
              //   window.open(
              //     "https://www.peerscroller.com/resources/pshe-association-content-guide",
              //     "_blank",
              //   );
              // }}
              className={
                window.location.pathname == "/resource-mapping"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                id="Map-Fill--Streamline-Outlined-Fill-Material"
                height="24"
                width="24"
              >
                <desc>Map Fill Streamline Icon: https://streamlinehq.com</desc>
                <path
                  fill="#000000"
                  d="M15.5 21.5 9 19.5l-6.5 2V5l6.5 -2 6.5 2 6.5 -2v16.5l-6.5 2ZM15.5 19.5v-13l-6.5 -2v13l6.5 2Z"
                  strokeWidth="0.5"
                />
              </svg>
              <p>Resource Mapping</p>
            </Link>
            <Link
              to="/help-support"
              className={
                window.location.pathname == "/help-support"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <g clipPath="url(#clip0_7001_6216)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0.9375 9C0.9375 4.5472 4.5472 0.9375 9 0.9375C13.4528 0.9375 17.0625 4.5472 17.0625 9C17.0625 13.4528 13.4528 17.0625 9 17.0625C4.5472 17.0625 0.9375 13.4528 0.9375 9ZM9 6.375C8.58577 6.375 8.25 6.71079 8.25 7.125C8.25 7.53923 7.91423 7.875 7.5 7.875C7.08578 7.875 6.75 7.53923 6.75 7.125C6.75 5.88236 7.75733 4.875 9 4.875C10.2427 4.875 11.25 5.88236 11.25 7.125C11.25 7.57177 11.119 7.99027 10.8931 8.34142C10.7575 8.5521 10.6003 8.7513 10.4603 8.9253L10.3837 9.02025C10.2678 9.16365 10.1649 9.29107 10.0695 9.42217C9.83243 9.74797 9.75 9.95775 9.75 10.125C9.75 10.5392 9.41422 10.875 9 10.875C8.58577 10.875 8.25 10.5392 8.25 10.125C8.25 9.4638 8.5746 8.92725 8.8566 8.53965C8.97652 8.37488 9.10808 8.21205 9.22447 8.0682L9.29167 7.98495C9.43042 7.81252 9.54308 7.6674 9.63165 7.52977C9.7065 7.4134 9.75 7.27543 9.75 7.125C9.75 6.71079 9.41422 6.375 9 6.375ZM8.99662 11.625C8.58427 11.625 8.25 11.9608 8.25 12.375C8.25 12.7892 8.58427 13.125 8.99662 13.125H9.00338C9.41573 13.125 9.75 12.7892 9.75 12.375C9.75 11.9608 9.41573 11.625 9.00338 11.625H8.99662Z"
                    fill="black"
                    fillOpacity="0.8"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_7001_6216">
                    <rect width="18" height="18" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <p>Help & Support</p>
            </Link>
            <Link
              to="/settings"
              className={
                window.location.pathname == "/settings"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                width="19"
                height="18"
                viewBox="0 0 19 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.64997 18C6.50962 17.9679 6.36326 17.9519 6.22893 17.9018C5.22246 17.5349 4.31023 17.0036 3.4862 16.32C3.06317 15.9691 2.96292 15.4559 3.18547 14.9046C3.57843 13.9263 3.43007 13.0281 2.73235 12.2382C2.34741 11.8032 1.8522 11.5546 1.27478 11.4744C0.553008 11.3742 0.218186 11.0574 0.103906 10.3277C-0.0604973 9.28919 -0.0264137 8.2507 0.182098 7.22024C0.292368 6.67293 0.677313 6.33813 1.25072 6.26195C2.88673 6.04544 3.84308 4.4817 3.28772 2.92999C3.07319 2.33056 3.21554 1.84941 3.71877 1.46248C4.4646 0.88711 5.2786 0.432022 6.15876 0.099227C6.7061 -0.107266 7.18528 0.0110162 7.56621 0.45207C8.64486 1.70306 10.3671 1.70506 11.4417 0.458084C11.8307 0.00500187 12.3018 -0.109271 12.8632 0.103237C13.8276 0.468108 14.7057 0.97933 15.5017 1.63289C15.9588 2.00779 16.0951 2.47089 15.9047 3.02622C15.3834 4.54986 16.2535 6.04944 17.8314 6.34214C18.4188 6.4504 18.7476 6.7852 18.8559 7.36659C19.0584 8.44316 19.0424 9.51573 18.8399 10.5903C18.7416 11.1075 18.3507 11.4744 17.8194 11.5566C16.1894 11.8032 15.2671 13.379 15.8465 14.9267C16.055 15.482 15.9247 15.9651 15.4676 16.342C14.7278 16.9475 13.9158 17.4326 13.0316 17.7955C12.5003 18.014 11.981 17.8757 11.6161 17.4246C10.5235 16.0694 8.67092 16.0934 7.61433 17.4788C7.37174 17.7975 7.06097 17.9739 6.64997 18ZM12.6707 8.97443C12.6707 7.24831 11.2472 5.8229 9.52101 5.8209C7.7627 5.8209 6.33519 7.23428 6.3372 8.97844C6.3392 10.7346 7.75067 12.148 9.50497 12.152C11.2533 12.154 12.6707 10.7306 12.6707 8.97443Z"
                  fill="black"
                  fillOpacity="0.8"
                />
              </svg>

              <p>Settings</p>
            </Link>

            {/* <Link
              to="/requested-packs"
              className={
                window.location.pathname == "/requested-packs"
                  ? "menu-btn bar_active"
                  : "menu-btn "
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20 2H4C3 2 2 2.9 2 4V22L6 18H20C21 18 22 17.1 22 16V4C22 2.9 21 2 20 2ZM20 16H5.2L4 17.2V4H20V16Z"
                  fill="black"
                />
                <path d="M7 9H17V11H7V9ZM7 12H14V14H7V12Z" fill="black" />
              </svg>
              <p>Requested Packs</p>
            </Link> */}
          </div>
        </div>
      </div>
      <SchoolInvitesOffcanvas
        show={showInvitesOffcanvas}
        handleClose={() => setShowInvitesOffcanvas(false)}
      />
    </aside>
  );
}
